"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchHelper = void 0;
class BatchHelper {
    constructor(onDrop, timeout) {
        this.onDrop = onDrop;
        this.timeout = timeout;
        this.timer = null;
        this.batch = new Set();
        this.drop = this.drop.bind(this);
    }
    add(item) {
        if (this.timer === null) {
            this.timer = setTimeout(this.drop, this.timeout);
        }
        this.batch.add(item);
    }
    drop() {
        this.timer = null;
        this.onDrop(Array.from(this.batch));
        this.batch.clear();
    }
}
exports.BatchHelper = BatchHelper;
